import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllAccessFromSystem extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Access/GetAllFromSystem");
  }
}
export { GetAllAccessFromSystem };
